import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface UsageStats {
  applications: number;
  jobPosts: number;
}

export function useSubscriptionUsage(userId?: string, userRole?: 'filmmaker' | 'client') {
  return useQuery({
    queryKey: ['subscription-usage', userId, userRole],
    queryFn: async (): Promise<UsageStats> => {
      if (!userId) {
        return { applications: 0, jobPosts: 0 };
      }

      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

      let applications = 0;
      let jobPosts = 0;

      // Get application count from subscription_usage_tracking
      if (userRole === 'filmmaker') {
        const { count } = await supabase
          .from('subscription_usage_tracking')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', userId)
          .eq('action_type', 'application')
          .gte('created_at', startOfMonth.toISOString());

        applications = count || 0;
      }

      // Get job post count from subscription_usage_tracking
      if (userRole === 'client') {
        const { count } = await supabase
          .from('subscription_usage_tracking')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', userId)
          .eq('action_type', 'job_post')
          .gte('created_at', startOfMonth.toISOString());

        jobPosts = count || 0;
      }

      return { applications, jobPosts };
    },
    enabled: !!userId && !!userRole,
    staleTime: 60 * 1000, // 1 minute
  });
}
